export const layoutsMap: Record<
  string,
  () => Promise<{ default: React.ComponentType<any> }>
> = {
  // Main backoffice layout
  MainLayout: () => import('./main/MainLayout/MainLayout'),

  // Main app webpage layout
  // HomepageLayout: () => import('./homepage-layout'),
  HomepageLayout: () => import('./main_f/MainLayout/MainLayout.tsx'),
  EmptyLayout: () => import('./EmptyLayout.tsx'),

  // Main user standalone webpage layout - TBD
  //...........IN PROGRESS.................

  //SANDBOX
  DashboardLayout: () => import('./dashboard-layout'),
  CompanyV1: () => import('./company-homepage-v1-layout'),
  CompanyV1Standalone: () => import('./company-homepage-v1-standalone-layout'),
  FirmamatuszakV1: () => import('./firmamatuszak/v1/firmamatuszak.v1.tsx')
  
  
  
  
  //SANDBOX_END
};
